module.exports = __webpack_public_path__ + "img/qr-wrapper.60254ef5.webp";